
import {mapGetters} from "vuex";
import {
  addImamHussainData,
  addHazratMassomehData,
} from "@/core/functions/localstorage-data";
import Vue from "vue";
import {HolyShrineType} from "@/enums/holy-shrine-type";

export default Vue.extend({
  name: "InquiryVerify",

  components: {},
  computed: {
    ...mapGetters({
      configInquiryRegister: "getConfigInquiryRegister",
    }),
  },
  watch: {
    configInquiryRegister: function () {
      this.isOpen = this.configInquiryRegister?.isOpen;
      this.imamHussainZiarat = this.configInquiryRegister.imamHussainZiarat;
      this.hazratMassomehZiarat =
          this.configInquiryRegister.hazratMassomehZiarat;
    },
  },
  data() {
    return {
      isOpen: false,
      imamHussainZiarat: false,
      hazratMassomehZiarat: false,
      Loading: false,
      mobileRules: [],
      verifyForm: {
        phoneNumber: null,
      },
      keyboardHeight: 0,
    };
  },
  mounted() {
  },
  methods: {
    handleBlurInput() {
      this.handleKeyboardHeight(0);
      this.validate();
    },
    handleFocusInput() {
      this.handleKeyboardHeight(250);
      this.clearRules();
    },
    handleKeyboardHeight(height: number) {
      setTimeout(() => {
        this.keyboardHeight = height;
      }, 0);
    },
    setRules() {
      this.mobileRules = [
        (value) => !!value || "شماره موبایل را وارد نمایید",
        (value) => /^09\d{9}$/.test(value) || "شماره همراه صحیح نمی باشد",
      ];
    },
    clearRules() {
      this.mobileRules = [];
    },
    validate() {
      this.setRules();
    },
    handleInquery() {
      this.isOpen = false;
    },
    verify() {
      const phoneNumber = this.verifyForm.phoneNumber;
      this.validate();

      setTimeout(() => {
        if (!(this.$refs as any).verifyForm.validate()) return;

        if (this.imamHussainZiarat) {
          this.Loading = true;
          addImamHussainData(phoneNumber);
          this.Loading = false;
          (this.$refs as any).verifyForm.reset();
          this.$store.commit("setconfigInquiryRegister", {
            isOpen: false
          });

          this.$router.push({
            name: "inquiry-details",
            params: {type: HolyShrineType.ImamHussain, id: phoneNumber},
          });
        } else {
          this.Loading = true;
          addHazratMassomehData(phoneNumber);
          this.Loading = false;
          (this.$refs as any)?.verifyForm?.reset();
          this.$store.commit("setconfigInquiryRegister", {
            isOpen: false
          });

          this.$router.push({
            name: "inquiry-details",
            params: {type: HolyShrineType.HazratMassomeh, id: phoneNumber},
          });
        }
      });

    }
  },
});
